/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { useTranslation } from 'react-i18next'
import SvgIcon from 'components/Icons/SvgIcon'

interface Props {
  ResetButton?: boolean
  title: string
  placeholder?: string
  initialValue: string
  currentValue: string
  caracterelimit?: number
  lineslimit?: number
  className?: string
  showLimitCounter?: boolean
  showLimitMessage?: boolean
  handleCurrentValueChange: (value: string) => void
  handleMouseDown?: () => void
  handleMouseUp?: () => void
}

const TextArea: React.FC<Props> = ({
  ResetButton,
  title,
  placeholder,
  initialValue,
  currentValue,
  className,
  caracterelimit = 1000,
  lineslimit = 5,
  handleCurrentValueChange,
  handleMouseDown,
  handleMouseUp,
  showLimitCounter,
  showLimitMessage,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={`textArea__container ${className}`}>
      {ResetButton && (
        <div className="textArea__header">
          <div className="textArea__title">
            <span>{title}</span>
          </div>
          <div className="textArea__reset">
            <button
              type="button"
              className="textArea__resetbutton"
              onClick={() => {
                handleCurrentValueChange(initialValue)
              }}
            >
              {t('infoBanner.textArea.resetText')}{' '}
              <SvgIcon name="synchronize" className="button_svg_spacing" />
            </button>
          </div>
        </div>
      )}
      <div className="textArea__textAreaContainer">
        {' '}
        <div className="textArea__form">
          <textarea
            value={currentValue}
            onChange={(e) => handleCurrentValueChange(e.target.value)}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            maxLength={caracterelimit}
            rows={lineslimit}
            className="textArea__box"
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="textArea__footer">
        {showLimitCounter && (
          <span>
            {t('infoBanner.textArea.charatersCount')}{' '}
            {currentValue?.length || 0}/{caracterelimit}
          </span>
        )}
        {showLimitMessage && currentValue?.length === caracterelimit && (
          <span className="textArea__footer__limit-message">
            {t('infoBanner.textArea.LimitMessage1')}
            {caracterelimit}
            {t('infoBanner.textArea.LimitMessage2')}
          </span>
        )}
      </div>
    </div>
  )
}
TextArea.defaultProps = {
  placeholder: '',
  caracterelimit: 255,
  lineslimit: 3,
  ResetButton: true,
  className: '',
  showLimitCounter: true,
  showLimitMessage: false,
  handleMouseDown: undefined,
  handleMouseUp: undefined,
}

export default TextArea
